import { Component, inject, OnInit, ViewChild } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { HtButtonIntent } from 'shared/base/ht-button/ht-button.component'
import {
  HtModalComponent,
  HtModalOptions,
} from 'shared/base/ht-modal/ht-modal.component'
import { AnalyticsEvents } from 'src/app/constants/analytics'
import { FeedbackService } from 'src/app/services/feedback.service'
import { Analytics } from 'utils/analytics'

@Component({
  selector: 'request-licenses-modal',
  templateUrl: './request-licenses-modal.component.html',
  standalone: false,
})
export class RequestLicensesModalComponent implements OnInit {
  private translate = inject(TranslateService)
  @ViewChild('modal') modal: HtModalComponent

  bodyText = this.translate.instant('shared.requestLicensesModal.body')

  modalOptions: HtModalOptions = {
    title: {
      text: this.translate.instant('shared.requestLicensesModal.title'),
    },
    size: 'small',
    rightBtnArray: [
      {
        show: true,
        text: this.translate.instant('common.cancel'),
        intent: HtButtonIntent.SECONDARY,
        click: () => this.modal.onClose(),
      },
      {
        show: true,
        text: this.translate.instant('shared.requestLicensesModal.sendRequest'),
        intent: HtButtonIntent.PRIMARY,
        click: () => this.onSubmit(),
      },
    ],
  }

  constructor(private feedbackService: FeedbackService) {}

  ngOnInit(): void {}

  onSubmit() {
    Analytics.event(AnalyticsEvents.LICENSES_REQUESTED)
    this.feedbackService.success(
      this.translate.instant('shared.requestLicensesModal.successMessage')
    )
    this.modal.close()
  }

  open() {
    Analytics.event(AnalyticsEvents.REQUEST_LICENSES_MODAL_OPEN)
    this.modal.open()
  }
}
